import { useEffect, useState } from 'react';

const ScrollProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const h = document.documentElement;
        const total = h.scrollHeight - h.clientHeight;
        setPct(total > 0 ? (h.scrollTop / total) * 100 : 0);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[2px] bg-transparent pointer-events-none">
      <div
        data-testid="scroll-progress"
        className="h-full bg-gradient-to-r from-primary via-accent to-clay transition-[width] duration-100 ease-out"
        style={{ width: `${pct}%`, boxShadow: '0 0 10px hsl(var(--primary) / 0.4)' }}
      />
    </div>
  );
};

export default ScrollProgress;
